import request from '@/utils/request'

// 分页fba计划
export function selectOrderTradeList(data) {
  return request({
    url: '/sOrderTradeStat/selectOrderTradeList',
    method: 'get',
    params: data
  })
}
// 分页fba计划
export function selectSOrderTradeList(data) {
  return request({
    url: '/server/order/selectSOrderTradeList',
    method: 'get',
    params: data
  })
}

// 分页fba计划
export function selectStatByAcountDetail(data) {
  return request({
    url: '/sDesignStat/selectStatByAcountDetail',
    method: 'get',
    params: data
  })
}
// 分页fba计划
export function selectStatByAcount(data) {
  return request({
    url: '/sDesignStat/selectStatByAcount',
    method: 'get',
    params: data
  })
}
// 分页fba计划
export function selectStatByPro(data) {
  return request({
    url: '/sDesignStat/selectStatByPro',
    method: 'get',
    params: data
  })
}
// 分页fba计划
export function selectStatByProDetail(data) {
  return request({
    url: '/sDesignStat/selectStatByProDetail',
    method: 'get',
    params: data
  })
}

// 分页fba计划
export function selectStatByDate(data) {
  return request({
    url: '/sOrderStat/selectStatByDate',
    method: 'get',
    params: data
  })
}

// 分页fba计划
export function selectStatShopDetail(data) {
  return request({
    url: '/sOrderStat/selectStatShopDetail',
    method: 'get',
    params: data
  })
}

// 分页fba计划
export function selectStatByShop(data) {
  return request({
    url: '/sOrderStat/selectStatByShop',
    method: 'get',
    params: data
  })
}

// 分页fba计划
export function selectStatDateDetail(data) {
  return request({
    url: '/sOrderStat/selectStatDateDetail',
    method: 'get',
    params: data
  })
}

export function selectFactoryBydateList(data) {
  return request({
    url: '/sFactoryStat/selectFactoryBydateList',
    method: 'get',
    params: data
  })
}

export function selectFactoryByAcountList(data) {
  return request({
    url: '/sFactoryStat/selectFactoryByAcountList',
    method: 'get',
    params: data
  })
}

export function selectFundListByDate(data) {
  return request({
    url: '/sFundStat/selectFundListByDate',
    method: 'get',
    params: data
  })
}

export function selectFundListByAcount(data) {
  return request({
    url: '/sFundStat/selectFundListByAcount',
    method: 'get',
    params: data
  })
}

export function selectProfitBydateList(data) {
  return request({
    url: '/sFactoryStat/selectProfitBydateList',
    method: 'get',
    params: data
  })
}

export function selectProfitByAcountList(data) {
  return request({
    url: '/sFactoryStat/selectProfitByAcountList',
    method: 'get',
    params: data
  })
}

export function selectStatList(data) {
  return request({
    url: '/sResourceStat/selectStatList',
    method: 'get',
    params: data
  })
}

export function selectGldStatByAcount(data) {
  return request({
    url: '/sDesignStat/selectGldStatByAcount',
    method: 'get',
    params: data
  })
}
export function selectGldStatByAcountDetail(data) {
  return request({
    url: '/sDesignStat/selectGldStatByAcountDetail',
    method: 'get',
    params: data
  })
}
export function selectGldStatByPro(data) {
  return request({
    url: '/sDesignStat/selectGldStatByPro',
    method: 'get',
    params: data
  })
}
export function selectGldStatByProDetail(data) {
  return request({
    url: '/sDesignStat/selectGldStatByProDetail',
    method: 'get',
    params: data
  })
}